export default {
    list: {
        title: 'Expedidores',
        subtitle: 'Gestiona tus colaboraciones con expedidores',
        loading: 'Cargando expedidores...',
        searchPlaceholder: 'Buscar por nombre o email...',
        countryPlaceholder: 'Filtrar por país',
        allCountries: 'Todos los países',
        tabs: {
            active: 'Expedidores Activos',
            pending: 'Invitaciones Pendientes',
        },
        active: {
            title: 'Expedidores Activos',
            description: 'Lista de expedidores con los que colaboras activamente',
            headers: {
                company: 'Empresa',
                country: 'País',
                email: 'Email',
                status: 'Estado',
                activeContainers: 'Contenedores Activos',
                totalContainers: 'Total de Contenedores',
                lastContainer: 'Último Contenedor',
                collaborationDate: 'Fecha de Colaboración',
                actions: 'Acciones',
            },
        },
        receivedInvites: {
            title: 'Invitaciones Recibidas',
            description: 'Invitaciones recibidas de expedidores esperando aceptación',
            headers: {
                company: 'Empresa',
                country: 'País',
                email: 'Email',
                inviteDate: 'Fecha de Invitación',
                actions: 'Acciones',
            },
            accept: 'Aceptar',
            reject: 'Rechazar',
            confirmAccept: '¿Estás seguro de que quieres aceptar esta invitación?',
            confirmReject: '¿Estás seguro de que quieres rechazar esta invitación?',
        },
        sentInvites: {
            title: 'Invitaciones Enviadas',
            description: 'Invitaciones enviadas a expedidores esperando su aceptación',
            headers: {
                company: 'Empresa',
                country: 'País',
                email: 'Email',
                inviteDate: 'Fecha de Invitación',
                actions: 'Acciones',
            },
        },
        status: {
            active: 'Activo',
            pending: 'Pendiente',
            rejected: 'Rechazado',
            suspended: 'Suspendido',
        },
        confirmSuspend: '¿Estás seguro de que quieres suspender esta colaboración?',
        confirmDelete: '¿Estás seguro de que quieres eliminar esta colaboración?',
        none: 'Ninguno',
    },
    detail: {
        loading: 'Cargando detalles del expedidor...',
        notFound: {
            title: 'Expedidor no encontrado',
            message: 'El expedidor solicitado no existe o no tienes permiso para verlo.',
        },
        backToList: 'Volver a la lista',
        info: {
            title: 'Información',
            collaboration: 'Colaboración',
            companyInfo: 'Información de la Empresa',
            containerStats: 'Estadísticas de Contenedores',
            fields: {
                legalName: 'Nombre Legal',
                entityType: 'Tipo de Entidad',
                taxId: 'ID Fiscal',
                country: 'País',
                address: 'Dirección',
                email: 'Email',
                phone: 'Teléfono',
            },
            stats: {
                total: 'Total',
                inTransit: 'En Tránsito',
                delivered: 'Entregados',
                delayed: 'Retrasados',
                pendingDocuments: 'Doc Pendiente',
                highRisk: 'Alto Riesgo',
            },
        },
        containers: {
            title: 'Contenedores de este Expedidor',
            count: 'de',
            searchPlaceholder: 'Buscar por ID de contenedor o ruta...',
            statusPlaceholder: 'Filtrar por estado',
            riskPlaceholder: 'Filtrar por riesgo',
            documentsPlaceholder: 'Filtrar por documentos',
            headers: {
                containerId: 'ID de Contenedor',
                route: 'Ruta',
                progress: 'Progreso',
                status: 'Estado',
                docStatus: 'Estado Doc',
                riskLevel: 'Nivel de Riesgo',
                value: 'Valor',
                actions: 'Acciones',
            },
            noContainers: {
                title: 'No se encontraron contenedores',
                message: 'Intenta modificar los filtros de búsqueda',
                emptyMessage: 'Aún no se han recibido contenedores de este expedidor',
            },
            viewDetails: 'Ver Detalles',
        },
    },
};

